type FetchEpisodesParams = {
  stationId: string;
  orderBy?: string;
  searchTitle?: string;
  limit?: number;
  pageToken?: string;
};

type Episode = {
  episodeId: number;
  webEpisodeId: string;
  title: string;
  publishOn: string;
  created: string;
  createdUnixTimestamp: number;
  totalPlays: number;
  duration: number;
  adCount: number;
  shareLinkPath: string;
  shareLinkEmbedPath: string;
  downloadUrl: string;
};

type FetchEpisodesResponse = {
  first: string;
  prev: string;
  next: string;
  last: string;
  limit: number;
  episodes: Episode[];
};

export async function fetchEpisodes({
  stationId,
}: FetchEpisodesParams): Promise<FetchEpisodesResponse> {
  try {
    const response = await fetch(
      `/api/proxy/v3/stations/webStationId:${stationId}/episode`
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error('Unable to fetch episodes');
  } catch (err) {
    throw new Error(err.message);
  }
}
